import { getUrl } from '../bibe'
import {
  CALLBACKS_PRODUCTION_URL,
  OIDC_IMPERSONATE_STOP_PATH,
} from './constants'
import { getOidcAuthorizeUrl } from './getOidcAuthorizeUrl'
import { navigateTo } from './navigateTo'
import { refreshAccessToken } from './refreshAccessToken'

/**
 * Renews the access token behind a rejected request, and sends the person to
 * sign in again when it cannot be renewed: an impersonated session stops
 * impersonating, and a missing or rejected refresh token re-authorizes through
 * the authorize route. A renewal that could not be carried out at all navigates
 * nowhere — the session is not known to be bad, so the caller surfaces the
 * original failure instead.
 *
 * @returns whether the rejected request is worth making again. `false` means
 * either that the caller is already navigating away, or that the renewal could
 * not be attempted; in both cases replaying the request would not help.
 */
export async function renewSession(): Promise<boolean> {
  const result = await refreshAccessToken()

  if (result === 'refreshed') {
    return true
  }

  if (result === 'unavailable') {
    return false
  }

  if (result === 'impersonation') {
    navigateTo(
      getUrl(`${CALLBACKS_PRODUCTION_URL}${OIDC_IMPERSONATE_STOP_PATH}`),
    )

    return false
  }

  navigateTo(getOidcAuthorizeUrl(window.location.href))

  return false
}
